import {canvasSpriteOffset} from './canvas-clipping.js';
import {Vector3} from 'three';
import {createAnimals,animalPose} from './animals.js';
import {createAnimalAnatomy,updateAnimalAnatomy} from './animals3d.js';

const TAU=Math.PI*2;
const point=new Vector3();
const finVertices=[[0,0,.42],[0,1,-.24],[0,0,-.65]];
const tailVertices=[[0,0,0],[0,.7,-1],[0,.11,-.60],[0,-.11,-.60],[0,-.7,-1]];
function projected(world,m,x,y,z){point.set(x,y,z).applyMatrix4(m);return world.project(point.x,point.y,point.z);}

/** The software renderer projects the very same articulated anatomical rig as WebGL. */
export function createAnimalsCanvas(terrain,seed,trees=[],rocks){
 const authoredFamilies=new Set(),data=createAnimals(terrain,seed,trees,rocks),rigs=data.animals.map(createAnimalAnatomy),ordered=rigs.flatMap(rig=>rig.parts.map(node=>({rig,node,depth:0,center:null})));
 return{data,rigs,setFamilyAuthored(type,active){active?authoredFamilies.add(type):authoredFamilies.delete(type);},draw(world,ctx,state=world.state,scenery=[]){
  for(const rig of rigs){if(authoredFamilies.has(rig.animal.type)&&(rig.animal.motionProfile||rig.animal.originalDoeProfile))animalPose(rig.animal,state,terrain,rig.pose,{semanticOnly:true});else updateAnimalAnatomy(rig,state,terrain);}
  for(const item of ordered){if(authoredFamilies.has(item.rig.animal.type))continue;item.center=projected(world,item.node.matrixWorld,0,0,0);item.depth=item.center.z;}
  // The cached landscape contains only ground/water. Interleave solid scenery
  // with the articulated parts so a resident behind a cabin or tree stays hidden.
  const visible=ordered.filter(item=>!authoredFamilies.has(item.rig.animal.type)),queue=scenery.length?[...visible,...scenery]:visible;
  queue.sort((a,b)=>b.depth-a.depth);
  ctx.save();
  for(const item of queue){
   if(item.draw){ctx.save();ctx.globalAlpha=1;item.draw(ctx);ctx.restore();continue;}
   const {node,rig,center:c}=item;
   const kind=node.userData.kind,m=node.matrixWorld,fish=rig.animal.type==='fish';
   ctx.globalAlpha=fish?.57*(1-(state.snowCover||0)*.86):1;ctx.fillStyle=node.userData.color;
   if(kind==='fin'||kind==='tail'){
    const vertices=(kind==='fin'?finVertices:tailVertices).map(v=>projected(world,m,...v));if(world.poly)world.poly(ctx,vertices,node.userData.color);else{ctx.beginPath();vertices.forEach((p,i)=>i?ctx.lineTo(p.x,p.y):ctx.moveTo(p.x,p.y));ctx.closePath();ctx.fill();}continue;
   }
   // Project three scaled axes and diagonalize their screen covariance. This keeps
   // all anatomy in perspective, including ears, foreshortened muzzles, and legs.
   if(c.visible===false)continue;
   const x=projected(world,m,1,0,0),y=projected(world,m,0,kind==='limb'?.5:1,0),z=projected(world,m,0,0,1);
   const dx=canvasSpriteOffset(c,x,world.w,world.h),dy=canvasSpriteOffset(c,y,world.w,world.h),dz=canvasSpriteOffset(c,z,world.w,world.h),ax=dx.x,ay=dx.y,bx=dy.x,by=dy.y,cx=dz.x,cy=dz.y;
   const xx=ax*ax+bx*bx+cx*cx,yy=ay*ay+by*by+cy*cy,xy=ax*ay+bx*by+cx*cy,disc=Math.sqrt((xx-yy)**2+4*xy*xy),rx=Math.max(.09,Math.sqrt(Math.max(0,(xx+yy+disc)*.5))),ry=Math.max(.09,Math.sqrt(Math.max(0,(xx+yy-disc)*.5))),angle=.5*Math.atan2(2*xy,xx-yy);
   if(!Number.isFinite(rx+ry+angle))continue;ctx.beginPath();ctx.ellipse(c.x,c.y,rx,ry,angle,0,TAU);ctx.fill();
   if(!fish&&rx>2.2&&ry>1.3){ctx.globalAlpha=.09;ctx.fillStyle='#fff7d9';ctx.beginPath();ctx.ellipse(c.x-rx*.12,c.y-ry*.2,rx*.65,ry*.47,angle,0,TAU);ctx.fill();}
  }
  ctx.restore();
 }};
}
